var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 61,
    viewBox: "0 0 80 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 30.5454C3.625 30.5454 16.8523 4.09082 40 4.09082C63.1477 4.09082 76.375 30.5454 76.375 30.5454C76.375 30.5454 63.1477 56.9999 40 56.9999C16.8523 56.9999 3.625 30.5454 3.625 30.5454Z",
    stroke: "#FF4A6B",
    strokeOpacity: 0.7,
    strokeWidth: 6.61364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9986 40.4661C45.4775 40.4661 49.919 36.0246 49.919 30.5457C49.919 25.0668 45.4775 20.6252 39.9986 20.6252C34.5197 20.6252 30.0781 25.0668 30.0781 30.5457C30.0781 36.0246 34.5197 40.4661 39.9986 40.4661Z",
    stroke: "#FF4A6B",
    strokeOpacity: 0.7,
    strokeWidth: 6.61364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.2a56713fa804e610cc2238e6cdc0907a.svg";
export { ForwardRef as ReactComponent };